/**
 * Cờ "đã tạo xong ít nhất một thiết kế" (đã tới Bước 3 và bấm Tải về/Chia sẻ ít nhất một lần) —
 * điều kiện để hiện nút "Chỉnh sâu hơn" (chế độ Nâng cao), theo docs/71-consumer-ux.md §9.
 * Lưu localStorage vì Phase 2 chưa có auth/session để lưu phía server.
 */
const KEY = "qrstudio.hasCompletedDesign";

export function hasCompletedDesign(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markDesignCompleted(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // localStorage có thể bị chặn (chế độ ẩn danh nghiêm ngặt, WebView hạn chế) — bỏ qua an toàn,
    // không chặn luồng tải/chia sẻ chỉ vì không ghi được cờ này.
  }
}
